import React from "react";
import ContentEditable from "react-contenteditable";

export default function ChecklistItemInput(props) {
  const {
    name,
    saveName,
    itemRef,
    isUnsaved,
    currentName,
    setCurrentName,
    inputRefs,
    ciIndex,
    nameRef,
  } = props;

  function handleInputNameChange(event) {
    const newName = event.target.value.replace(/[&]?nbsp;/gi, " ");
    setCurrentName(newName);
    nameRef.current = newName;
  }

  function handleInputBlur(event) {
    const trimmedName = nameRef.current.replace(/[&]?nbsp;/gi, " ").trim();
    if (trimmedName !== name || trimmedName !== currentName || isUnsaved) {
      setCurrentName(trimmedName);
      saveName(trimmedName);
    }
  }

  inputRefs[ciIndex] = itemRef;
  return (
    <ContentEditable
      innerRef={itemRef}
      onBlur={handleInputBlur}
      onChange={handleInputNameChange}
      html={currentName}
      className={"checklist-item-name"}
    />
  );
}
